import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");

for (const element of elements) {
  let accordion = new Accordion(element, {
    multipleOpen: true,
    onOpen: (trigger, panel) => {},
    onClose: (trigger, panel) => {}
  });
}


//アコーディオンの矢印の向きを変える
const accordions = Array.from(document.querySelectorAll('.js-accordion-trigger'));

accordions.forEach((accordion) => {
  accordion.addEventListener('click', () => {
    if(accordion.getAttribute('aria-expanded') === 'true') {
      accordion.querySelector('.js-accordion-arrow').classList.add('is-active');
    } else {
      accordion.querySelector('.js-accordion-arrow').classList.remove('is-active');
    }
  });
});

// accordion.destroy()
// accordion.init()
